let ticket = [
  {
    path: '/wechat/order-ticket',
    name: '微信小票',
    component: () => import('@/pages/ticket/wechat/main_ticket')
  }
]

export default ticket
